import { AxiosInstance } from 'axios';
import { ClassWorkplaceRepository } from '@/model/repository/shift/ClassWorkplaceRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): ClassWorkplaceRepository => ({
    update(id, payload) {
      return Repository.put(`${resource}/${id}`, payload);
    },
  });
